import { render, staticRenderFns } from "./SelectedAssetDispatchTable.vue?vue&type=template&id=82fdb2ee&scoped=true"
import script from "./SelectedAssetDispatchTable.vue?vue&type=script&lang=js"
export * from "./SelectedAssetDispatchTable.vue?vue&type=script&lang=js"
import style0 from "./SelectedAssetDispatchTable.vue?vue&type=style&index=0&id=82fdb2ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fdb2ee",
  null
  
)

export default component.exports